import type { PriorityPlaylist } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { PriorityTask } from '@backrs_ui/grow-ui/src/redux/priorities/priorities.types';

export const useAgentContext = (playlist?: PriorityPlaylist | null, tasks?: PriorityTask[]) => {
  useRegisterAgentContext(
    playlist
      ? {
          kind: 'entity',
          description: 'The playbook the user is viewing',
          data: {
            id: playlist.id,
            title: playlist.title,
            description: playlist.description,
            total_tasks: playlist.total_tasks,
            completed_tasks: playlist.completed_tasks,
          },
        }
      : null,
  );

  useRegisterAgentContext(
    tasks
      ? {
          kind: 'list',
          description: 'Tasks in the playbook being viewed',
          data: {
            tasks: tasks.map((task) => ({
              id: task.id,
              title: task.title,
              description: task.description,
              priority: task.priority,
              status_code: task.status_code,
              due_date: task.due_date,
            })),
          },
        }
      : null,
  );
};
